import { Component, ViewEncapsulation } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'save-btn-cell',
  template: `
  <button
  *ngIf="isTodayCountDate"
  class="save_btn"
  (click)="onClick()"
>
  Save
</button>
  `,
  styles: [`
    .save_btn {
      position: relative;
      top: 0px;
      float: right;
      width: 50px;
      height: 23px;
      color: white;
      background: #e10a1d;
      border: none !important;
      border-radius: 35px !important;
      opacity: 1;
      right: 2%;
      font-weight: 50;
      padding: 0px;
      font-size: 12px;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }
  `],
  encapsulation: ViewEncapsulation.None
  //*styleUrls: ['./save-child-parts-count.component.scss']//
})
export class SaveChildPartscountComponent implements ICellRendererAngularComp {
  public params: any;
  public isTodayCountDate = false;

  agInit(params: any): void {
    this.params = params;
    this.isTodayCountDate = this.checkIfToday(params.data?.countdate);
  }

  refresh(): boolean {
    return false;
  }

  onClick(): void {
    if (this.params.clicked) {
      this.params.clicked(this.params.data);
    }
  }

  private checkIfToday(countDateStr: string): boolean {
    if (!countDateStr) return false;

    const [month, day, year] = countDateStr.split('/');
    const countDate = new Date(+year, +month - 1, +day);
    const today = new Date();

    return (
      countDate.getDate() === today.getDate() &&
      countDate.getMonth() === today.getMonth() &&
      countDate.getFullYear() === today.getFullYear()
    );
  }
}
